import { render, staticRenderFns } from "./PaymentSettingsBankAccounts.vue?vue&type=template&id=54f77f84&scoped=true&"
import script from "./PaymentSettingsBankAccounts.vue?vue&type=script&lang=js&"
export * from "./PaymentSettingsBankAccounts.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSettingsBankAccounts.vue?vue&type=style&index=0&id=54f77f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f77f84",
  null
  
)

export default component.exports